import React from 'react';

import useDispensary from 'src/dispensary/hooks/use-dispensary';
import { useIsAccountEnabled } from 'src/hooks/use-is-account-enabled';
import { RemoteComponentSlot, useRemoteComponent } from 'src/hooks/use-remote-component';
import { Navigation } from 'src/dispensary/core-menu/components/header/navigation';
import StoreFrontHeader from 'src/dispensary/core-menu/components/core-menu-header/store-front-header';

type PageRootProps = {
  children: React.ReactNode;
  showHeader?: boolean;
  showNavigation?: boolean;
};

function isRegionEnabled(value: unknown): boolean {
  return value !== false;
}

/**
 * Shared root render for the CMS editors (standalone page + menu landing page).
 * Conditionally shows the StoreFront header and navigation around the page content.
 */
export function PageRootRender({ children, showHeader = true, showNavigation = true }: PageRootProps): JSX.Element {
  const headerEnabled = isRegionEnabled(showHeader);
  const navEnabled = isRegionEnabled(showNavigation);

  const { dispensary } = useDispensary();
  const isAccountEnabled = useIsAccountEnabled();
  const ResolvedNavigation = useRemoteComponent(RemoteComponentSlot.Navigation, { fallback: Navigation });

  return (
    <div style={{ background: 'var(--dcm-cms-page-bg, #fff)', width: '100%', minHeight: '100vh' }}>
      {headerEnabled && <StoreFrontHeader />}
      {navEnabled && dispensary && <ResolvedNavigation dispensary={dispensary} isAccountEnabled={isAccountEnabled} />}
      {children}
    </div>
  );
}
